<template>
  <div class="bottomDialogBox citySelect" v-if='isShowDialog'>
    <div class="bottomDialogMask" v-bind:class="{fadeIn:isShowDialog,animated:isShowDialog}"></div>
    <div class="bottomDialog" v-bind:class="{slideInUp:isShowDialog,animated:isShowDialog}">
      <div class="title">
        {{title}}
        <i class="icon iconfont iconcha" @click='hideDialog'></i>
      </div>
      <div class="dialogBox">
        <div class="ui_citySelect">
          <div class='scrollBox' scroll-y="true" :scroll-into-view="toView">
            <p class="posDesc" id='#' v-if='currentCity.cityCode'>当前城市</p>
            <p class="currentCity" v-if='currentCity.cityCode' @click='chooseCurrentCity(currentCity)'>
              {{currentCity.cityName}}</p>
            <p class="posDesc" v-if="historyCityList.length > 0">历史选择</p>
            <div class="hotCityList" v-if="historyCityList.length > 0">
              <p class="hotCity" v-for="(historyCity, historyCityIndex) in historyCityList" :key="historyCityIndex"
                @click="chooseCity(historyCity)">
                {{ historyCity.descript }}
              </p>
            </div>
            <p class="posDesc" id='热' v-if="hotCityList.length>0">热门城市</p>
            <div class="hotCityList" v-if="hotCityList.length>0">
              <p class="hotCity" v-for="(hotCity,hotCityIndex) in hotCityList" :key="hotCityIndex"
                @click='chooseCity(hotCity)'>
                {{hotCity.descript}}
              </p>
            </div>
            <p class="posDesc">选择城市</p>
            <div v-if="isOpenAllCountyCitySearch">
              <h4 class='cityLetter'>ALL</h4>
              <p @click="chooseAll()" class='cityName'>全国</p>
            </div>
            <div v-for='(group,groupIndex) in cityList' :key='groupIndex'>
              <h4 class='cityLetter' :id='groupIndex'>{{groupIndex}}</h4>
              <p v-for='(city,cityIndex) in group' @click='chooseCity(city)' :key='cityIndex' class='cityName'>
                {{city.descript}}</p>
            </div>
          </div>
          <div class="index">
            <div class="letterWrapper">
              <div @click.stop="gotoView('#')" class="letter">#</div>
              <div @click.stop="gotoView('热')" v-if='hotCityList.length>0' class="letter">热</div>
              <div v-for='(group,groupIndex) in cityList' :key='groupIndex' @click='gotoView(groupIndex)'
                class="letter">{{groupIndex}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { jAlert3 } from "@/base/jAlert/jAlert";
import api from "@/utils/api";
import { setStorage, getStorage } from "@/utils/wxuser";
var config = {};
export default {
  props: ["currentCity", "isOpenAllCountyCitySearch"],
  data() {
    return {
      isShowDialog: false,
      title: "城市选择",
      toView: "#",
      cityList: {},
      hotCityList: [],
      historyCityList: [],
    };
  },
  mounted() {
    config = getStorage("config");
    this.getCityList();
    this.getHotCityList();
    this.historyCityList = getStorage("historyCityList") || [];
  },
  created() {},
  beforeDestroy() {
    this.isShowDialog = false;
  },
  methods: {
    showDialog() {
      this.isShowDialog = true;
      this.$emit("no-scroll", true);
    },
    hideDialog() {
      this.isShowDialog = false;
      this.$emit("no-scroll", false);
    },
    getCityList() {
      var self = this;
      api
        .getCityList({
          hotelGroupCode: config.hotelGroupCode,
          sortType: "asc",
          hotelCode:config.hotelCode,
        })
        .then(function (response) {
          if (response.result == 1) {
            self.cityList = response.retVal;
          }
        });
    },
    getHotCityList() {
      var self = this;
      api
        .hotCity({
          hotelGroupCode: config.hotelGroupCode,
          sortType: "asc",
          hotelCode:config.hotelCode,
        })
        .then(function (response) {
          if (response.result == 1) {
            self.hotCityList = response.retVal;
          }
        });
    },
    gotoView(index) {
      this.toView = index;
      document
        .getElementById(index)
        .scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "start",
        });
      jAlert3(index);
    },
    chooseCity(selectCity) {
      if (selectCity && selectCity.code) {
        var obj = {
          code: selectCity.code,
          descript: selectCity.descript,
        };
        this.changeCity = obj;
        this.$emit("changeCity", this.changeCity);
        this.storeCity(obj);
      }
    },
    chooseAll() {
      var obj = {
        code: "",
        descript: "",
      };
      this.changeCity = obj;
      this.$emit("changeCity", this.changeCity);
      this.storeCity(obj);
    },
    chooseCurrentCity(currentCity) {
      if (currentCity && currentCity.cityCode) {
        var obj = {
          code: currentCity.cityCode,
          descript: currentCity.cityName,
        };
        this.changeCity = obj;
        this.$emit("changeCity", this.changeCity);
        this.storeCity(obj);
      }
    },
    storeCity(obj) {
      setStorage("cityName", obj.descript);
      setStorage("cityCode", obj.code);
      if(obj.descript&&obj.code){
				this.setHistoryCity({
					code: obj.code,
					descript: obj.descript
				});
			}
    },
    setHistoryCity(obj) {
      let historyCityList = getStorage("historyCityList") || [];
      let index = -1;
      historyCityList.forEach((n, i) => {
        if (n.code == obj.code) {
          index = i;
        }
      });
      if (index > -1) {
        historyCityList.splice(index, 1);
        historyCityList.unshift(obj);
      } else {
        if (historyCityList.length >= 4) {
          historyCityList.splice(historyCityList.length - 1, 1);
        }
        historyCityList.unshift(obj);
      }
      setStorage("historyCityList", historyCityList);
      this.historyCityList = historyCityList;
    },
  },
};
</script>
<style lang="less" scoped>
@import url("~@/styles/skin.less");
@import url("~@/styles/mixin.less");
.bottomDialogBox {
  &.citySelect {
    .bottomDialog {
      .dialogBox {
        padding: 0px;
      }
    }
  }
  .bottomDialogMask {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .bottomDialog {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: auto;
    z-index: 101;
    .title {
      height: 44px;
      line-height: 44px;
      text-align: center;
      font-size: @font-size-large;
      color: @color-font;
      background: @color-background;
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      position: relative;
      .iconcha {
        position: absolute;
        color: @color-font;
        font-size: 14px;
        right: 5px;
        top: -10px;
        border: 10px solid transparent;
      }
    }
    .dialogBox {
      background-color: @color-background-d;
      padding: 0 12px 12px 12px;
      .ui_citySelect {
        position: relative;
        padding-bottom: 10px;
        max-height: 400px;
        overflow-y: scroll;
        .scrollBox {
          max-height: 400px;
          overflow-y: scroll;
        }
        .posDesc {
          margin: 16px auto 16px 20px;
          font-size: @font-size-medium-x;
          color: @color-font;
        }
        .currentCity {
          margin-left: 20px;
          border: 1px solid #979797;
          border-radius: 4px;
          font-size: @font-size-medium-x;
          color: @color-font;
          display: inline-block;
          padding: 6px 16px;
        }
        .hotCityList {
          padding: 0 20px;
          padding-right: 33px;
          .hotCity {
            border: 1px solid #979797;
            border-radius: 4px;
            font-size: @font-size-medium-x;
            color: @color-font;
            display: inline-block;
            padding: 6px 14px;
            margin-right: 3px;
            margin-bottom: 8px;
          }
        }
        .cityLetter {
          height: 32px;
          line-height: 32px;
          background: @color-background;
          text-indent: 20px;
          font-size: @font-size-medium-x;
          color: @color-font;
        }
        .cityName {
          height: 44px;
          line-height: 44px;
          text-indent: 20px;
          font-size: @font-size-medium-x;
          color: @color-font;
        }
        .index {
          position: absolute;
          left: calc(~"100% - 48px");
          top: 44px;
          height: calc(~"100% - 44px");
          display: flex;
          flex-direction: column;
          justify-content: center;
          .letterWrapper {
            background: rgba(255, 255, 255, 0.5);
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
            border-radius: 15px;
            padding: 10px 0;
            text-align: center;
            &:last-child {
              padding-bottom: 0px;
            }
          }
          .letter {
            font-size: @font-size-medium;
            color: @color-font;
            margin-bottom: 5px;
            padding: 2px 10px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hotel/citySelect/citySelect.vue